// extracted by mini-css-extract-plugin
module.exports = {"parent":"Airback_parent__2BOeJ","fadein":"Airback_fadein__2BLE0","zoom":"Airback_zoom__3pb_q"};